import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      tipRules: [
        v => Rules.isRequired(v)
      ],
      spoilRules: [
        v => Rules.isRequired(v)
      ],
      siteWeightRules: [
        v => (
          !this.trip.end && !this.trip.start && !this.trip.qty ? !!v : true
        ) || 'Must enter either Tip Weight or start / end times',
        v => Rules.isNumber(v)
      ],
      scaleWeightRules: [
      ],
      startRules: [
        v => (
          !!this.trip.end ? !!v : true
        ) || 'Must enter end and start times',
      ],
      endRules: [
        v => (
          !!this.trip.start ? !!v : true
        ) || 'Must enter end and start times',
        v => (
          !this.trip.siteWeight ? !!v : true
        ) || 'Must enter either Tip Weight or start / end times'
      ],
      tipWeightRules: [
      ],
      wbDocketNumberRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 50)
      ],
      noteRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 250),
      ],
    }
  }
}
